<core-form-dialog>
  <core-form-dialog-layout pageTitle="Manage language and date format" i18n-pageTitle>
    <app-date-lang-format></app-date-lang-format>
  </core-form-dialog-layout>
</core-form-dialog>
